export default __webpack_public_path__ + "static/media/checkCircleIcon.95295a9f.svg";